// src/components/ProtectedRoute.js
import { useAuth } from '../hooks/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import Main from '../layouts/Main'; // Your layout with Sidebar

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Main>  {/* This wraps Sidebar + Content */}
      <Outlet />  {/* Child routes render here */}
    </Main>
  );
};

export default ProtectedRoute;